export enum ZIndexRange {
  Loaders = 3000,
  Globals = 4000,
  Sidebar = 4100,
  Header = 4200,
  Dropdowns = 5000,
  FormFields = 6000,
  Modals = 7000,
  Toasts = 8000,
  Extra = 9000,
}
